export const translationsWdith = {
  'ALL--composit_width--key': 'Breite',
  'ALL--width_source--key': 'Quelle Breite',
  'ALL--width_source=ALKIS': 'Aus ALKIS Daten ausgemessen',
  'ALL--width_source=ARCore': 'Mit dem Handy-Metermaß von StreetComplete gemessen',
  'ALL--width--key': 'Breite',
}
